import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { useApi } from '../../../hooks/useApi';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

// 对话框可见性

export default /*@__PURE__*/_defineComponent({
  __name: 'TicketDialog',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false);
// 当前选中的点券套餐ID
const currentTicketPackageId = ref('');
// 加载状态
const loading = ref(false);
// 表格引用
const tableRef = ref<any>();


// 表格列定义
const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'id',
    label: '点券码',
    type: 'numberStr',
    isCondition: true,
  },
  {
    name: 'beanCount',
    label: 'AI豆数',
    type: 'string',
  },
  {
    name: 'isVerified',
    label: '使用状态',
    type: 'select',
    options: [
      { label: '未使用', value: 0 },
      { label: '已使用', value: 1 },
    ],
    render: (scope: any) => (scope?.row?.isVerified === 1 ? '已使用' : '未使用'),
  },
  {
    name: 'verifiedPhone',
    label: '使用手机号',
    type: 'string',
    isCondition: true,
    render: (scope: any) => (scope?.row?.verifiedPhone ? String(scope.row.verifiedPhone) : '暂无'),
  },
  {
    name: 'expireTime',
    label: '过期时间',
    type: 'string',
    render: (scope: any) => (scope?.row?.expireTime ? dayjs(scope.row.expireTime).format('YYYY-MM-DD HH:mm:ss') : '暂无'),
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '暂无'),
  },
]));

// 获取数据
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;

    // 处理查询条件，确保不会有undefined或null值
    const processedConditions = Object.entries(filter.conditions || {}).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, any>);

    // 添加点券套餐ID作为查询条件
    const res = await useApi().ticketApi.pageTicketticket({
      conditions: {
        ...processedConditions,
        ticketPackageId: parseInt(currentTicketPackageId.value, 10),
      },
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    // 返回表格数据
    const tableData: HpsfirProTableData = {
      data: res.data.data?.data || [],
      total: res.data.data?.total || 0,
    };

    return tableData;
  } catch (error) {
    console.error('获取数据失败:', error);
    ElMessage.error('获取数据失败');
    return {
      data: [],
      total: 0,
    };
  } finally {
    loading.value = false;
  }
});

// 关闭对话框
const handleClose = () => {
  dialogVisible.value = false;
};

// 打开对话框
const open = (ticketPackageId: number) => {
  currentTicketPackageId.value = ticketPackageId.toString();
  dialogVisible.value = true;
  // 延迟刷新表格，确保对话框已完全打开
  setTimeout(() => {
    tableRef.value?.refresh();
  }, 0);
};

// 暴露方法给父组件
__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: dialogVisible.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "点券列表",
    width: "80vw",
    "max-width": "1200px",
    "content-class": "business-table-drawer",
    "body-class": "business-table-drawer__body"
  }, {
    default: _withCtx(() => [
      (dialogVisible.value)
        ? (_openBlock(), _createBlock(_component_HpsfirProTable, {
            key: 0,
            "export-file-name": "点券列表",
            columns: columns.value,
            "get-data": _unref(getData),
            paginations: { pageSize: 10 },
            ref_key: "tableRef",
            ref: tableRef,
            height: "500px",
            "destroy-on-close": "",
            loading: loading.value
          }, null, 8, ["columns", "get-data", "loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})